import { Locale } from 'date-fns';

export const getDateLocale = async (
  langCode: string | undefined,
): Promise<Locale> => {
  const lowerCaseLangCode = langCode?.toLowerCase();
  switch (lowerCaseLangCode) {
    case 'cz':
    case 'cs':
    case 'cs-cz':
      return (await import('date-fns/locale/cs')).cs;

    case 'de':
    case 'de-de':
      return (await import('date-fns/locale/de')).de;

    case 'en-GB':
      return (await import('date-fns/locale/en-GB')).enGB;

    case 'es':
    case 'es-es':
      return (await import('date-fns/locale/es')).es;

    case 'fr':
    case 'fr-fr':
    case 'fr-ca':
    case 'fr-ch':
      return (await import('date-fns/locale/fr')).fr;

    case 'it':
      return (await import('date-fns/locale/it')).it;

    case 'ja':
    case 'jp':
    case 'ja-jp':
      return (await import('date-fns/locale/ja')).ja;

    case 'ko':
    case 'kr':
    case 'ko-kr':
      return (await import('date-fns/locale/ko')).ko;

    case 'pt':
    case 'pt-pt':
    case 'pt-br':
      return (await import('date-fns/locale/pt')).pt;

    case 'ru':
      return (await import('date-fns/locale/ru')).ru;

    case 'ZH':
    case 'zh-CN':
    case 'zh-SG':
    case 'zh-Hans':
      return (await import('date-fns/locale/zh-CN')).zhCN;

    case 'zh-HK':
    case 'zh-MO':
    case 'zh-Hant':
    case 'zh-TW':
      return (await import('date-fns/locale/zh-TW')).zhTW;

    default:
      return (await import('date-fns/locale/en-US')).enUS;
  }
};
